import styled from '../../../theme/styled-with-theme';
import { pxToRem } from '../../../styles/utils';
import { mediaQueries } from '../../../styles/media-queries';
import { Button as StyledButton } from '../styles';

export const Button = styled(StyledButton)`
  min-width: ${pxToRem(110)};
  min-height: ${pxToRem(45)};
  -webkit-tap-highlight-color: transparent;

  transition: all 0.3s cubic-bezier(0, 0.7, 0.3, 1.01);
  will-change: width, flex-grow;

  ${({ theme }) => `
    height: ${pxToRem(45)};
    font-size: ${theme.fontSize.m};
    border-radius: ${theme.borderRadius.input_mobile_nav};
  `}

  ${mediaQueries.desktop} {
    min-width: ${pxToRem(110)};
    min-height: ${pxToRem(36)};
    height: ${pxToRem(56)};
    font-size: ${({ theme }) => theme.fontSize.m};
    border-radius: ${({ theme }) => theme.borderRadius.input_mobile_nav};
  }
`;

export const TransparentButton = styled(Button)`
  min-width: ${pxToRem(90)};
  color: ${({ theme }) => theme.color.inputLabelText};
  font-size: ${({ theme }) => theme.fontSize.m};
  padding: ${({ theme }) => `0 ${theme.spacing.s}`};

  ${mediaQueries.desktop} {
    min-width: ${pxToRem(90)};
    color: ${({ theme }) => theme.color.inputLabelText};
    font-size: ${({ theme }) => theme.fontSize.smm};
    padding: ${({ theme }) => `0 ${theme.spacing.s}`};
  }

  &:hover {
    color: ${({ theme }) => theme.color.inputLabelText};
    text-decoration: underline;
  }
`;
